if (!Array.prototype.fill) {
    Object.defineProperty(Array.prototype, 'fill', {
        /**
         * Value.
         *
         * @param {mixed} value
         *
         * @return {boolean}
         */
        value: function(value) {
            // Steps 1-2.
            if (this == null) {
                throw new TypeError('this is null or not defined');
            }

            const O = Object(this);

            // Steps 3-5.
            const len = O.length >>> 0;

            // Steps 6-7.
            const start = arguments[1];

            const relativeStart = start >> 0;

            // Step 8.
            let k = Math.min(relativeStart, len);

            if (relativeStart < 0) {
                k = Math.max(len + relativeStart, 0);
            }

            // Steps 9-10.
            const end = arguments[2];

            let relativeEnd = end >> 0;

            if (end === undefined) {
                relativeEnd = len;
            }

            // Step 11.
            let final = Math.min(relativeEnd, len);

            if (relativeEnd < 0) {
                final = Math.max(len + relativeEnd, 0);
            }

            // Step 12.
            while (k < final) {
                O[k] = value;
                k++;
            }

            // Step 13.
            return O;
        }
    });
}
